import type { ProfilesData } from "../store/useAuthStore";
import { clarity } from "react-microsoft-clarity";

export const clarityProjectId: string =
  import.meta.env.VITE_MICROSOFT_CLARITY_KEY?.trim() || "dnxzyp10mw";

/** [Clarity] only on deployed staging/production builds (not dev or preprod). */
export const isClarityEnabled =
  import.meta.env.MODE === "production" || import.meta.env.MODE === "staging";

function clarityIdentify(customUserId: string): void {
  const friendlyName = `UAM ${customUserId}`;
  if (typeof window.clarity !== "function") {
    if (import.meta.env.DEV) {
      console.warn("[Clarity] identify skipped — clarity not loaded yet");
    }
    return;
  }
  if (import.meta.env.DEV) {
    console.log("[Clarity] identify custom user id (uam_id):", customUserId);
  }
  window.clarity("identify", customUserId);
  clarity.identify(customUserId, {});

  if (typeof window.clarity === "function") {
    window.clarity(
      "identify",
      customUserId,
      undefined,
      undefined,
      friendlyName,
    );
    window.clarity("set", "userUamId", customUserId);
    window.clarity("set", "uam_id", customUserId);
    return;
  }

  clarity.setTag("userUamId", customUserId);
  clarity.setTag("uam_id", customUserId);
}

export function getDefaultProfileUamId(
  profilesData: ProfilesData | null,
): string | null {
  const profiles = profilesData?.unified_account_details?.profiles;
  if (!profiles?.length) {
    return null;
  }
  const profile = profiles.find((p) => p.is_default_profile) ?? profiles[0];
  if (!profile || profile.uam_id == null) {
    return null;
  }
  return String(profile.uam_id);
}

export function syncClarityCustomUserId(
  profilesData: ProfilesData | null,
): void {
  if (!isClarityEnabled) {
    return;
  }
  const customUserId = getDefaultProfileUamId(profilesData);
  if (!customUserId) {
    return;
  }
  clarityIdentify(customUserId);
}

export function resetClarityCustomUserIdCache(): void {}
